import styled from 'styled-components';

export const LangSelectorContainer = styled.div`
  display: inline-flex;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.colors.primary};
    height: 16px;
    width: 16px;
    margin-right: 8px;
  }
`;
